import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './serviceWorkerRegistration';

// Only register service worker in production to avoid development reload issues
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  console.log('🔧 Development mode: Service Worker disabled to prevent reload loops');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
